

// import React, { useState } from "react";
// import { Container, Row, Col } from "react-bootstrap";
// import { FaFacebookF, FaTwitter, FaInstagram, FaTiktok, FaPinterestP, FaLinkedinIn } from "react-icons/fa";
// import logoicon from "../../Images/vantaralogo.png";
// const Footer = () => {
//   const [open, setOpen] = useState(null); // track which section is open

//   const toggleSection = (section) => {
//     setOpen(open === section ? null : section);
//   };

//   return (
//     <footer className="bg-white pt-4 pb-5">
//       <Container>
//         <Row>

//           <Col md={3} className="mb-4 mb-md-0 pe-md-4">
//             <img
//               src={logoicon}
//               alt="VANTHARA Logo"
//              style={{ height: "40px", objectFit: "contain", marginBottom: "15px" }}
//             />

//             <p className="text-muted mb-1 small">549 Oak St.Crystal Lake, IL 60014</p>
//             <a href="#" className="d-block text-muted small text-decoration-underline mb-2">GET DIRECTION</a>
//             <a href="mailto:themesflat@gmail.com" className="text-muted small">themesflat@gmail.com</a>

 
//             <div className="d-flex gap-2 mt-3">
//               {[FaFacebookF, FaTwitter, FaInstagram, FaTiktok, FaPinterestP, FaLinkedinIn].map((Icon, i) => (
//                 <a key={i} href="#" className="btn btn-outline-dark rounded-circle p-2 d-flex align-items-center justify-content-center" style={{ width: "36px", height: "36px" }}>
//                   <Icon size={14} />
//                 </a>
//               ))}
//             </div>
//           </Col>

//           {/* Information - Accordion in mobile */}
//           <Col md={2} className="mb-4 mb-md-0">
//             <div className="d-flex justify-content-between align-items-center d-md-block">
//               <h4 className="fw-bold mb-0 fs-6">Information</h4>
//               <button
//                 className="btn btn-sm d-md-none"
//                 onClick={() => toggleSection("info")}
//               >
//                 {open === "info" ? "-" : "+"}
//               </button>
//             </div>
//             <ul className={`list-unstyled mt-3 d-md-block ${open === "info" ? "d-block" : "d-none d-md-block"}`}>
//               <li><a href="/about" className="text-muted small text-decoration-none">About Us</a></li>
//               <li><a href="#" className="text-muted small text-decoration-none">Our Stories</a></li>
//               <li><a href="#" className="text-muted small text-decoration-none">Size Guide</a></li>
//               <li><a href="/contact" className="text-muted small text-decoration-none">Contact us</a></li>
//               <li><a href="#" className="text-muted small text-decoration-none">Career</a></li>
//               <li><a href="/account" className="text-muted small text-decoration-none">My Account</a></li>
//             </ul>
//           </Col>

//           {/* Customer Services - Accordion in mobile */}
//           <Col md={2} className="mb-4 mb-md-0">
//             <div className="d-flex justify-content-between align-items-center d-md-block">
//               <h4 className="fw-bold mb-0 fs-6">Customer Services</h4>
//               <button
//                 className="btn btn-sm d-md-none"
//                 onClick={() => toggleSection("services")}
//               >
//                 {open === "services" ? "-" : "+"}
//               </button>
//             </div>
//             <ul className={`list-unstyled mt-3 d-md-block ${open === "services" ? "d-block" : "d-none d-md-block"}`}>
//               <li><a href="#" className="text-muted small text-decoration-none">Shipping</a></li>
//               <li><a href="#" className="text-muted small text-decoration-none">Return & Refund</a></li>
//               <li><a href="#" className="text-muted small text-decoration-none">Privacy Policy</a></li>
//               <li><a href="#" className="text-muted small text-decoration-none">Terms & Conditions</a></li>
//               <li><a href="#" className="text-muted small text-decoration-none">Ordered FAQs</a></li>
//               <li><a href="#" className="text-muted small text-decoration-none">My Website</a></li>
//             </ul>
//           </Col>

//           {/* Newsletter (no accordion, keep always open) */}
//           <Col md={5}>
//             <h4 className="fw-bold mb-3 fs-6">Newsletter</h4>
//             <p className="text-muted small mb-3">
//               Sign up for our newsletter and get 10% off your first purchase
//             </p>

//             <div className="d-flex mb-3">
//               <input
//                 type="email"
//                 placeholder="Enter your e-mail..."
//                 className="form-control rounded-0 border-end-0 border-secondary"
//               />
//               <button className="btn btn-dark rounded-0 px-3">→</button>
//             </div>

//             <p className="text-muted small mb-1">
//               By clicking subscribe, you agree to the Terms of Service PID OWS
//             </p>
//             <a href="#" className="text-dark small text-decoration-underline">Privacy Policy</a>
//           </Col>
//         </Row>
//       </Container>

//       <Container>
//         <Row>
//           <Col className="text-center border-top pt-3">
//             <p className="text-muted small mb-0">©2024 VANTHARA. All Rights Reserved.</p>
//           </Col>
//         </Row>
//       </Container>
//     </footer>
//   );
// };

// export default Footer;


import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaTiktok,
  FaPinterestP,
} from "react-icons/fa";
import logoicon from "../../Images/vantaralogo.png";
import { Link } from "react-router-dom";

const Footer = () => {
  const [open, setOpen] = useState(null);

  const toggleSection = (section) => {
    setOpen(open === section ? null : section);
  };

  return (
    <footer className="bg-white pt-5 pb-4" style={{ fontFamily: "Kumbh Sans, sans-serif" }}>
      <Container>
        <Row className="gy-4">
          {/* Left Section */}
          <Col md={3} className="pe-md-4">
            <img
              src={logoicon}
              alt="Logo"
              style={{ height: "28px", objectFit: "contain", marginBottom: "20px" }}
            />

            <p className="text-dark  mb-1">Old Vythiri, Vythiri, Kunnathidavaka, Kerala 673576</p>
            <a
              href="#"
              className="d-block text-dark fw-semibold  mb-3 text-decoration-none"
            >
              GET DIRECTION ↗
            </a>

            <p className="mb-1 ">
              <a href="mailto:themesflat@gmail.com" className="text-dark text-decoration-none">
                vantara@gmail.com
              </a>
            </p>
            <p className="mb-3 ">
              <a href="tel:3156666688" className="text-dark text-decoration-none">
                315-666-6688
              </a>
            </p>

            <div className="d-flex gap-2">
              {[FaFacebookF, FaTwitter, FaInstagram, FaTiktok, FaPinterestP].map(
                (Icon, i) => (
                  <a
                    key={i}
                    href="#"
                    className="border rounded-circle d-flex align-items-center justify-content-center"
                    style={{ width: "36px", height: "36px" }}
                  >
                    <Icon size={14} className="text-dark" />
                  </a>
                )
              )}
            </div>
          </Col>

          {/* Information */}
          <Col md={2}>
            <div className="d-flex justify-content-between align-items-center d-md-block">
              <h6 className="fw-bold">Information</h6>
              <button
                className="btn btn-sm d-md-none"
                onClick={() => toggleSection("info")}
              >
                {open === "info" ? "-" : "+"}
              </button>
            </div>
            <ul
              className={`list-unstyled mt-3 d-md-block ${
                open === "info" ? "d-block" : "d-none d-md-block"
              }`}
            >
             <li><Link to="/about" className="text-dark text-decoration-none">About Us</Link></li>
<li><Link to="/stories" className="text-dark text-decoration-none">Our Stories</Link></li>
{/* <li><Link to="/size-guide" className="text-dark text-decoration-none">Size Guide</Link></li> */}
<li><Link to="/contact" className="text-dark text-decoration-none">Contact Us</Link></li>
<li><Link to="/faq" className="text-dark text-decoration-none">FAQ</Link></li>
<li><Link to="/account" className="text-dark text-decoration-none">My Account</Link></li>
            </ul>
          </Col>

          {/* Customer Services */}
          <Col md={2}>
            <div className="d-flex justify-content-between align-items-center d-md-block">
              <h6 className="fw-bold">Customer Services</h6>
              <button
                className="btn btn-sm d-md-none"
                onClick={() => toggleSection("services")}
              >
                {open === "services" ? "-" : "+"}
              </button>
            </div>
            <ul
              className={`list-unstyled mt-3 d-md-block ${
                open === "services" ? "d-block" : "d-none d-md-block"
              }`}
            >
             <li><Link to="/shipping" className="text-dark text-decoration-none">Shipping</Link></li>
<li><Link to="/policy" className="text-dark text-decoration-none">Return & Refund</Link></li>
<li><Link to="/privacy-policy" className="text-dark text-decoration-none">Privacy Policy</Link></li>
<li><Link to="/terms-conditions" className="text-dark text-decoration-none">Terms & Conditions</Link></li>
{/* <li><Link to="/orders-faqs" className="text-dark text-decoration-none">Orders FAQs</Link></li> */}
<li><Link to="/wholesale-enquiry" className="text-dark text-decoration-none">Wholesale Enquiry</Link></li>
            </ul>
          </Col>

          {/* Newsletter */}
    {/* Newsletter */}
<Col md={5}>
  {/* <h6 className="fw-bold">Newsletter</h6> */}
  <p className=" mb-3">
    Sign up for your purchase
  </p>

<div className="position-relative mb-3">
  <input
    type="email"
    placeholder="Enter your e-mail"
    className="form-control rounded-pill px-4 py-2"
    style={{ paddingRight: "55px" }} // make space for button
  />
  <button
    className="btn position-absolute top-50 end-0 translate-middle-y me-2 d-flex align-items-center justify-content-center"
    style={{
      width: "40px",
      height: "40px",
      borderRadius: "50%",
      backgroundColor: "#1C3F1D",
      color: "white",
      fontSize: "18px",
      lineHeight: "1",
      transition: "all 0.3s ease",
    }}
    onMouseOver={(e) => {
      e.currentTarget.style.backgroundColor = "white";
      e.currentTarget.style.color = "black";
      e.currentTarget.style.border = "1px solid black";
    }}
    onMouseOut={(e) => {
      e.currentTarget.style.backgroundColor = "black";
      e.currentTarget.style.color = "white";
      e.currentTarget.style.border = "none";
    }}
  >
    →
  </button>
</div>


  <p className=" mb-0">
    <input type="checkbox" className="me-2" /> By clicking subscribe, you agree to the{" "}
    <a href="#" className="text-dark fw-semibold text-decoration-underline">
      Terms of Service
    </a>{" "}
    and{" "}
    <a href="#" className="text-dark fw-semibold text-decoration-underline">
      Privacy Policy
    </a>.
  </p>
</Col>

        </Row>

        <hr className="my-4" />

        {/* Bottom Row */}
        <Row className="align-items-center">
          <Col md={6} className="small text-muted">
            ©2025 Vantara. All Rights Reserved.
          </Col>
          <Col
            md={6}
            className="d-flex justify-content-md-end align-items-center gap-3 small"
          >
            <span>USD</span>
            <span>English</span>
            <span className="d-flex gap-2">
              <img src="https://upload.wikimedia.org/wikipedia/commons/0/04/Visa.svg" height="20" alt="visa" />
              <img src="https://upload.wikimedia.org/wikipedia/commons/3/30/American_Express_logo.svg" height="20" alt="amex" />
              <img src="https://modavenextjs.vercel.app/images/payment/img-6.png" height="20" alt="mastercard" />
              <img src="https://modavenextjs.vercel.app/images/payment/img-4.png" height="20" alt="discover" />
            </span>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
